import * as z from "zod/v4";
import { boolean, literal, object, string } from "zod/v4";
import { ContentType } from "../../conversation";
import { BaseMessageDbParser } from "../base-conversation-message-db-parser";
import { AutoGeneratedFieldsSchema } from "../message-parser-utils";
//TODO I think we can remove
/**
 * This is the message type for the response to the (original) tool call to
 * subscribe to back in stock notifications.
 * @deprecated in favor of subscribe to back in stock
 */
export const BackInStockNotificationMessageContentSchema = object({
  productId: string(),
  variantId: string(),
  subscribed: boolean(),
  error: string().optional(),
});
export const BackInStockNotificationMessageSchema = BaseMessageDbParser.extend({
  contentType: literal(ContentType.SUBSCRIBE_TO_BACK_IN_STOCK_NOTIFICATION),
  structuredContent: z.object({
    subscriptionsResult: z
      .array(BackInStockNotificationMessageContentSchema)
      .optional(),
    customerEmail: z.string().email(),
    message: z.string(),
  }),
});

export const BackInStockNotificationMessageDbParser =
  BackInStockNotificationMessageSchema.merge(AutoGeneratedFieldsSchema);
